<template>
  <div v-if="section">
    <h1 class="text-center" v-text="section.title"></h1>
    <v-row>
      <p v-html="section.desc"></p>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="4"
        lg="4"
        class="px-5"
        v-for="(block, index) in section.blocks"
        :key="index"
      >
        <v-list-item :key="block.title">
          <v-list-item-avatar justify="left" tile width="100" height="50">
            <carousel-image
              v-if="block && block.images && block.images.length > 0"
              :slides="getImageUrls(block.images)"
              :height="200"
              :cycle="false"
              :continuous="false"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <h3 v-text="block.title"></h3>
          </v-list-item-content>
        </v-list-item>
        <v-row>
          <p justify="right" v-html="block.content"></p>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import CarouselImage from "@/views/home/page/CarouselImage.vue";

@Component({
  name: "Blocks2",
  components: { CarouselImage },
  props: {
    section: {
      default: null,
    },
  },
})
export default class Blocks2 extends Vue {
  images = [];
  getImageUrls(images) {
    const urls = [];
    if (images && images.length > 0) {
      for (let i = 0; i < images.length; i++) {
        if (images[i] && images[i].url) {
          urls.push(images[i].url);
        }
      }
    }
    return urls;
  }
}
</script>
